import { HasAccess } from 'components';
import { usePurchaseOrderByIdQuery } from 'api';
import React, { useCallback } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { Tasks } from 'components/common/tasks/tasks';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const PurchaseOrderTasks = React.memo(() => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { hasAccess } = useAccessControl();
  const { data: { purchaseOrder = {} } = {} } = usePurchaseOrderByIdQuery({ id }, { skip: !id });
  const onAdd = useCallback(
    () =>
      navigate(ADMIN_ROUTES.purchaseOrder.createTask, {
        state: {
          entityName: 'PURCHASE_ORDER',
          entityId: id,
        },
      }),
    [navigate, id]
  );
  const onRedirectToTask = useCallback(
    (value: string) => navigate(`${ADMIN_ROUTES.purchaseOrder.view}/${id}/tasks/${value}`),
    [navigate, id]
  );
  return (
    <HasAccess role={PERMISSIONS.tasks.task.read}>
      <Tasks
        entityType="PURCHASE_ORDER"
        entityId={id}
        hasAccessToWrite={hasAccess(PERMISSIONS.tasks.task.write) && !purchaseOrder?.isFinalStatus}
        hasAccessToDelete={hasAccess(PERMISSIONS.tasks.task.delete) && !purchaseOrder?.isFinalStatus}
        showAnalytics={false}
        onTaskAdd={onAdd}
        onRedirectToTask={onRedirectToTask}
      />
    </HasAccess>
  );
});
